import React, { useState, useEffect } from "react";
import { Modal, Button, notification, Select, Form, Popconfirm } from "antd";
import axiosInstance from "utilities/axios";

const DSDEditModal = ({ division, open, onClose, onChange }) => {
  const [form] = Form.useForm();

  const [employeeOptions, setEmployeeOptions] = useState([]);

  useEffect(() => {
    axiosInstance.get("/employees").then((response) => {
      setEmployeeOptions(response.data);
    });
  }, []);

  const onFinish = (values) => {
    axiosInstance
      .put(`/divisions/${division.divisionCode}`, {
        dsdInitials: values.employee,
      })
      .then(() => {
        notification.success({
          message: "Divisional Sales Director Updated",
          description:
            "The Divisional Sales Director has been successfully updated",
        });
        onChange();
      })
      .catch((error) => {
        notification.error({
          message: "Failed to update Divisional Sales Director",
          description: error.reponse.data.error,
        });
      });
  };

  return (
    <Modal
      title="Edit Divisional Sales Director"
      open={open}
      onCancel={onClose}
      footer={[]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="employee"
          label="Select New Divisional Sales Director"
          rules={[{ required: true, message: "Please select an employee" }]}
        >
          <Select
            showSearch
            placeholder="Select an employee"
            style={{ width: "100%" }}
            filterOption={(input, option) => {
              const optionData = employeeOptions.find(
                (opt) => opt.initials === option.value
              );
              if (!optionData) {
                return false;
              }
              return (
                optionData.firstName
                  .toLowerCase()
                  .includes(input.toLowerCase()) ||
                optionData.lastName
                  .toLowerCase()
                  .includes(input.toLowerCase()) ||
                optionData.initials.toLowerCase().includes(input.toLowerCase())
              );
            }}
          >
            {employeeOptions.map((employee) => (
              <Select.Option key={employee.initials} value={employee.initials}>
                {employee.firstName} {employee.lastName} - {employee.initials}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Popconfirm
          title={
            <>
              Are you sure you want to go through with this change?
              <br />
              This will removed the current Divisional Sales Director.
            </>
          }
          onConfirm={() => onFinish(form.getFieldsValue())}
          okText="Yes"
          cancelText="No"
          placement="bottom"
        >
          <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
            Update Divisional Sales Director
          </Button>
        </Popconfirm>
      </Form>
    </Modal>
  );
};

export default DSDEditModal;
